import RMSExistingHoldingContainer from "./RMSExistingHoldingContainerN";
import RMSExistingHoldingStore from "./RMSExistingHoldingStoreN";

export default RMSExistingHoldingStore(RMSExistingHoldingContainer);